$ = require 'jquery'
Browser = require '@trello/browser'
Footer = require 'app/scripts/views/footer'
Auth = require 'app/scripts/db/auth'
{ getQueryParameter } = require 'app/scripts/lib/util'

module.exports =
  maybeShowFooterChrome: (url) ->
    $el = $('#footer-chrome')
    $el.hide()

    if Browser.isEmbeddedDocument() and @onAnyBoardView()
      $el.show()
      footerView = new Footer({
        url
        shouldDisplayLogout: ->
          getQueryParameter('iframeSource', '') is 'msteams' and Auth.isLoggedIn()
      })
      $el.html footerView.render().el
